import {
  ChangeDetectionStrategy, ChangeDetectorRef,
  Component,
  EventEmitter,
  Inject,
  Input,
  OnChanges,
  OnDestroy,
  OnInit,
  Output,
  SimpleChanges
} from '@angular/core';
import {Observable, Subject, Subscription, of} from 'rxjs';
import {catchError, debounceTime, distinctUntilChanged, switchMap, tap} from 'rxjs/operators';
import * as _ from 'lodash';
import {AdminHttpService} from "../../../../account/angular/services/admin-http.service";

require('./admin-autocomplete-input.scss');
@Component({
  standalone: false,
  selector: 'app-admin-autocomplete-input',
  templateUrl: './admin-autocomplete-input.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class AdminAutocompleteInputComponent implements OnInit, OnChanges, OnDestroy {
  @Input() adminIds: string[] = [];
  @Input() label: string;
  @Input() isRequired: boolean = false;
  @Input() isDisabled: boolean = false;
  @Input() placeholder: string = 'Select admins';

  @Output() onSelect = new EventEmitter<{ admins: any[], adminIds: string[] }>();
  @Output() onClear = new EventEmitter<void>();

  public adminItems: any[] = []; // Selected admins
  public searchResults: any[] = []; // Search results
  public loading = false;
  public searchInput$ = new Subject<string>();
  private subscription: Subscription = new Subscription();

  constructor(@Inject(AdminHttpService) private adminHttpService: AdminHttpService,
              @Inject(ChangeDetectorRef) private cdr: ChangeDetectorRef) {
  }

  ngOnInit() {

    if(this.adminIds) {
      this.loadAdminsByIds(this.adminIds);
    }
    // Setup search with debounce
    this.subscription.add(
      this.searchInput$.pipe(
        debounceTime(300),
        distinctUntilChanged(),
        tap(() => this.loading = true),
        switchMap(term => this.searchAdmins(term)),
        tap(() => this.loading = false) // Ensure loading is set to false after search completes
      ).subscribe()
    );
  }

  ngOnChanges(changes: SimpleChanges) {
    // If adminIds input changes, load the corresponding admins
    // if (changes.adminIds) {
    //   const currentIds = changes.adminIds.currentValue || [];
    //   const previousIds = changes.adminIds.previousValue || [];
    //
    //   if (!_.isEqual(currentIds, previousIds)) {
    //     this.loadAdminsByIds(currentIds);
    //   }
    // }
  }

  ngOnDestroy() {
    this.subscription.unsubscribe();
  }

  onSearch(term: string) {
    this.searchInput$.next(term);
  }

  onSelectionChange(selectedAdmins: any[]) {
    this.adminItems = selectedAdmins || [];
    const adminIds = this.adminItems.map(admin => admin.id);
    this.onSelect.emit({admins: this.adminItems, adminIds});
  }

  onClearSelection() {
    this.adminItems = [];
    this.onClear.emit();
  }

  private loadAdminsByIds(ids: string[]) {
    if (!ids || ids.length === 0) {
      this.adminItems = [];
      return;
    }

    this.loading = true;
    this.adminHttpService.getByIds(ids)
      .pipe(
        catchError(error => {
          console.error('Error loading admins:', error);
          this.loading = false;
          return of([]);
        })
      )
      .subscribe(admins => {
        // Store the loaded admins in the component's adminItems array
        // This ensures they are displayed as selected in the dropdown
        this.adminItems = admins;
        this.loading = false;
        this.cdr.detectChanges();

      });
  }

  private searchAdmins(term: string): Observable<any[]> {
    if (!term || term.length < 2) {
      this.loading = false;
      this.searchResults = [];
      return of([]);
    }

    return this.adminHttpService.searchByTerm(term)
      .pipe(
        catchError(error => {
          console.error('Error searching admins:', error);
          this.loading = false;
          this.searchResults = [];
          return of([]);
        }),
        tap(admins => {
          this.searchResults = admins;
          this.loading = false;
          this.cdr.detectChanges();
        })
      );
  }

  compareWith(item: any, selected: any): boolean {
    return item && selected && item.id === selected.id;
  }

  protected readonly requestAnimationFrame = requestAnimationFrame;
}
